import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
	icons: {
		iconfont: 'fa', // use fa instead of faSVG
		// values: ICONS, for customizing icons const ICONS = {}
	},
	customProperties: true,
	theme: {
		themes: {
			light: {
				primary: '#a22380',
				secondary: '#4BA2C9',
				accent: '#82B1FF',
				error: '#FF5252',
				info: '#2196F3',
				success: '#4CAF50',
				warning: '#FFC107',
			},
		},
	},
});
